var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg003Giraffe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343 496.837c98.558-35.61 169-129.997 169-240.837 0-141.385-114.615-256-256-256s-256 114.615-256 256c0 110.84 70.442 205.228 169 240.837z",
    fill: "#c38778"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a65d4e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169 270.547-24.531 14.974 24.531 24.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169 222.694 130.719 25.724 43.281 248.419c98.558-35.61 169-129.997 169-240.837 0-13.856-1.101-27.454-3.22-40.713l-73.92-74.816-91.423-90.527-31.466 103.348-103.348-103.348-28.834 135.076-88.307-4.668 77.518 77.519z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.563 496.679c27.282 9.914 56.728 15.321 87.437 15.321s60.155-5.407 87.438-15.321v-281.242h-174.875z",
    fill: "#fdba12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 215.437v296.563c30.709 0 60.154-5.407 87.438-15.321v-281.242z",
    fill: "#ffa300"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m389.219 230.064c0 64.775-59.644 88.615-133.219 88.615s-133.219-23.841-133.219-88.615c0-64.775 59.644-139.439 133.219-139.439s133.219 74.664 133.219 139.439z",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 90.625v228.054c73.575 0 133.219-23.841 133.219-88.615 0-64.775-59.644-139.439-133.219-139.439z",
    fill: "#fdba12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.394,
    cy: 204.652,
    fill: "#555a66",
    rx: 17.267,
    ry: 17.267,
    transform: "matrix(.926 -.379 .379 .926 -63.99 83.933)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.606,
    cy: 204.652,
    fill: "#333940",
    rx: 17.267,
    ry: 17.267,
    transform: "matrix(.787 -.618 .618 .787 -55.807 247.869)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.405,
    cy: 265.53,
    fill: "#414952",
    rx: 9.53,
    ry: 9.53,
    transform: "matrix(.707 -.707 .707 .707 -117.345 247.764)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.595,
    cy: 265.53,
    fill: "#23272b",
    rx: 9.53,
    ry: 9.53,
    transform: "matrix(.229 -.974 .974 .229 -49.036 469.161)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.562 65.573h40.06v78.19h-40.06z",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m303.377 65.573h40.06v78.19h-40.06z",
    fill: "#fdba12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.423 187.385h-55.703c-19.65 0-35.58-15.93-35.58-35.58v-11.333h91.284v46.913z",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.577 187.385h55.703c19.651 0 35.581-15.93 35.581-35.58v-11.333h-91.284z",
    fill: "#fdba12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 188.593,
    cy: 65.573,
    fill: "#ffce00",
    r: 25.412
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 323.407,
    cy: 65.573,
    fill: "#fdba12",
    r: 25.412
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.563 423.314 31.432-10.858 19.276-49.253-50.708-9.511z",
    fill: "#ff9d00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.438 426.276-45.443-8.523-11.556 55.747 56.999 16.108z",
    fill: "#fe8205"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003Giraffe);
export default __webpack_public_path__ + "static/media/003-giraffe.b9cd90a562282c57d0ebcb7d3853213a.svg";
export { ForwardRef as ReactComponent };